import { useMedia } from 'react-use';

export default () => {
  return useMedia('(prefers-reduced-motion: reduce)');
};
